import React from "react";
import Spinner from "../Spinner";
import Cart from "./Cart";
import { MdShoppingCart, MdClose } from "react-icons/md";
import { getCart } from "../../api/api";

// redux
import { useDispatch, useSelector } from "react-redux";
import { setCart, setCheckoutUrl, toggleMiniCart } from "../../redux/cartSlice";

// modal
import Modal from "react-modal";
Modal.setAppElement(".react-root-mini-cart");

export default function MiniCart() {
  // We get the element from a hidden div and place it
  // in the modal as it comes from episerver.
  let html = "";
  let element = document.getElementById("minicart-content-area");
  if (element !== null) {
    html = element.innerHTML;
  }

  const totalCount = useSelector((state) => state.cartData.totalCount);
  const show = useSelector((state) => state.cartData.showMiniCart);
  const dispatch = useDispatch();

  const [loading, setLoading] = React.useState(false);
  const [error, setError] = React.useState(false);
  const [showSuccessShare, setShowSuccessShare] = React.useState(false);
  const [showSuccessMessage, setShowSuccessMessage] = React.useState("");

  React.useEffect(() => {
    loadCart();
  }, []);

  const loadCart = async () => {
    setLoading(true);

    let data = await getCart();
    if (!data) {
      setError(true);
      setLoading(false);
      return;
    }

    dispatch(setCart(data.items));
    dispatch(setCheckoutUrl(data.checkoutPageUrl));
    setLoading(false);
  };

  const handleSuccessShare = (message) => {
    setShowSuccessShare(true);
    setShowSuccessMessage(message);

    // setTimeout(() => {
    //   setShowSuccessShare(false);
    //   setShowSuccessMessage("");
    // }, 3000);
  };

  if (loading) {
    return <Spinner />;
  }

  if (error) {
    return <p>{i18n.getString("common.error")}</p>;
  }

  return (
    <div className="c-mini-cart__container noselect">
      <div className="c-mini-cart__info-container" onClick={() => dispatch(toggleMiniCart())}>
        <span className="c-mini-cart__icon">
          <MdShoppingCart />
        </span>
        {!loading && (
          <span
            className={`c-mini-cart__item-count ${totalCount > 0 ? "green" : ""} ${totalCount > 99 && "max-reached"}`}
          >
            <span>{totalCount > 99 ? "99+" : totalCount}</span>
          </span>
        )}
      </div>

      <Modal
        preventScroll={true}
        closeTimeoutMS={200}
        isOpen={show}
        onRequestClose={() => dispatch(toggleMiniCart())}
        className="c-mini-cart__modal"
        overlayClassName="c-mini-cart__modal-overlay"
        portalClassName="c-mini-cart__modal-portal"
      >
        <div className="c-mini-cart__modal-header">
          <h3>
            {i18n.getString("inquiryList.heading")} ({totalCount > 99 ? "99+" : totalCount})
          </h3>
          <MdClose
            style={{ cursor: "pointer" }}
            className="c-cart__trash-icon"
            onClick={() => dispatch(toggleMiniCart())}
          />
        </div>

        <div className="c-mini-cart__modal-content">
          {/* temp 
          {showSuccessShare && (
            <span className="c-mini-cart__shared-successfully">
              {showSuccessMessage}
              <MdClose style={{ cursor: "pointer" }} onClick={() => setShowSuccessShare(false)} />
            </span>
          )}
          */}

          <Cart showSuccessShare={(message) => handleSuccessShare(message)} />
        </div>

        {html !== "" && (
          <div className="c-mini-cart__modal-footer">
            <div dangerouslySetInnerHTML={{ __html: html }}></div>
          </div>
        )}
      </Modal>
    </div>
  );
}
